import './Submenu.css'
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import {NavLink} from 'react-router-dom'
import cn from 'classnames'
import {createSelector} from 'reselect'
import {routesUrls} from "../../settings/routes";
import {FaAngleRight} from "react-icons/fa";


class Submenu extends Component {
    constructor() {
        super();
        this.state = {
            collapsed: true
        }
    }

    handleCollapse = () => {
        this.setState((state) => ({collapsed: !state.collapsed}))
    }
    render() {
        const {collapsed} = this.state;
        let {formatMessage} = this.context
        return (
            <div className={cn([
                'aside',
                {'active': !collapsed}
            ])}>
                <button className={'btn btn-collapse btn-link'} onClick={this.handleCollapse}>
                    <FaAngleRight className={'icon'}/>
                </button>
                <ul className={cn([
                    'nav'
                ])}>
                    {
                        this.getSubmenuItems()
                            .map(({text, to}) => {
                                return (
                                    <li
                                        className={cn([

                                        ])}
                                        key = {text}>
                                        <NavLink
                                            className = {cn([

                                            ])}
                                            activeClassName = "active"
                                            to = {to}
                                        >{formatMessage(text)}</NavLink>
                                    </li>
                                )
                            })
                    }
                </ul>
            </div>
        )
    }

    getSubmenuItems = createSelector(() => {
        return Submenu.SUBMENUTITEMS
    })

    static SUBMENUTITEMS = [
        {
            to : routesUrls.adminTranslations,
            text : "Translations",
        },
        {
            to : routesUrls.adminSupportQuestion,
            text : "SupportQuestion",
        },
        {
            to: routesUrls.adminUsersList,
            text: "Users"
        },
        {
            to: routesUrls.adminDiscounts,
            text: "Discount"
        },
        {
            to: routesUrls.adminTeacherFeetback,
            text: "TeacherFeetback"
        },
        {
            to: routesUrls.adminPlans,
            text: "Plan payment"
        },
        {
            to : routesUrls.adminTransactions,
            text : "Transactions",
        },
        {
            to : routesUrls.adminSettings,
            text : "Settings",
        },
    ]

    static contextTypes = {formatMessage: PropTypes.any}
}

export default Submenu



// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/AdminPanel/Submenu.js